const Loading = ({ className = "" }) => {
    return (
        <div className={`flex justify-center items-center ${className}`}>
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-300 border-t-main"></div>
        </div>
    );
};

export default Loading;

